export default __webpack_public_path__ + "static/media/guide30.b4b7518b.png";